import { PageLayout } from '@/layouts'
import AgreementTable, { Agreement } from './agreementTable'
import { useFetchAllAgreementByIdClient } from '../services/useFetchAllAgreementByIdClient'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function ListarAgreementsClients() {
  const { cnpjcpf } = useParams<{ cnpjcpf?: string }>() // << nome certo

  const navigate = useNavigate()
  const {
    data = [],
    isLoading,
    isFetching,
    isError,
    error,
    refetch
  } = useFetchAllAgreementByIdClient(cnpjcpf, {
    enabled: !!cnpjcpf
  })
  console.log(data)
  const handleAgreementClick = (agreement: Agreement) => {
    navigate(`/minuta/${agreement.id_client}`)
  }
  // Loading
  if (isLoading || isFetching) {
    return (
      <PageLayout title="Lista de Minutas">
        <div className="flex items-center justify-center gap-3 py-16 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" />
          Carregando minutas...
        </div>
      </PageLayout>
    )
  }
  // Erro
  if (isError) {
    return (
      <PageLayout title="Lista de Minutas">
        <div className="py-16 text-center">
          <p className="text-destructive">Ocorreu um erro ao carregar as minutas.</p>
          <p className="text-sm text-muted-foreground mt-1">
            {(error as any)?.message ?? 'Tente novamente mais tarde.'}
          </p>
          <Button onClick={() => refetch()} className="mt-4">
            Tentar novamente
          </Button>
        </div>
      </PageLayout>
    )
  }
  return (
    <PageLayout title="Lista de Minutas">
      <AgreementTable agreement={data} onClickAgreement={handleAgreementClick} />
    </PageLayout>
  )
}
